import React, { useCallback, useImperativeHandle, useState } from 'react'
import PropTypes from 'prop-types'
import RoundedModal from '../../../../../../molecules/RoundedModal'
import AddComponentForm from './form'

const AddComponentDialog = React.forwardRef(function AddComponentDialog ({ onComplete }, ref) {
  const [dialogState, setDialogState] = useState({ open: false })

  const close = useCallback(() => {
    setDialogState({ open: false })
  }, [setDialogState])

  const handleComplete = useCallback((result) => {
    close()
    onComplete(result)
  }, [close, onComplete])

  useImperativeHandle(ref, () => ({
    open: () => {
      setDialogState({ open: true })
    }
  }), [setDialogState])

  return (
    <RoundedModal
      title='Add Component'
      open={dialogState.open}
      onClose={close}
      size='md'
      position='top'
      disablePortal={false}
    >
      <div>
        {dialogState.open ? (
          <AddComponentForm
            onComplete={handleComplete}
            onCancel={close}
          />
        ) : null}
      </div>
    </RoundedModal>
  )
})

AddComponentDialog.propTypes = {
  onComplete: PropTypes.func
}

AddComponentDialog.defaultProps = {
  onComplete: () => {}
}

export default AddComponentDialog
